import {Component, Input, OnDestroy, OnInit} from "@angular/core";
import { Aangifte, BokkzAlgDataService, IncomeTaxEntity } from "@snelstart-ventures/fiscaal/domain-logic";
import {FormBuilder, FormGroup} from "@angular/forms";
import {BokkzIbDataService} from "@snelstart-ventures/fiscaal/domain-logic";
import {BehaviorSubject, filter, Subscription} from "rxjs";
import {Event, NavigationEnd, Router} from "@angular/router";
import { SharedUiDetailsModule } from '@snelstart/ui-details';
import { SharedUiFormControlsModule } from '@snelstart/ui-form-controls';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'snelstart-venture-fiscaal-feature-loon-onderdeel-winst',
  templateUrl: './loon-onderdeel-winst.component.html',
  styleUrls: ['./loon-onderdeel-winst.component.scss'],
  imports: [
    SharedUiDetailsModule,
    SharedUiFormControlsModule,
    CommonModule
  ]
})
export class LoonOnderdeelWinstComponent implements OnInit, OnDestroy {

    @Input() public id!: string;
    @Input() partner = new BehaviorSubject<boolean>(false);
    public clientId!: string;

    private focusedElementId: string | null = null;
    private partnerAangifte = {} as Aangifte
    private routerSubscription: Subscription | undefined;
    private incomeTaxEntitySubscription: Subscription | undefined;
    private clientEntitySubscription: Subscription | undefined;
    private isDefAangifteSubscription: Subscription | undefined;
    private isSaving = false;
    public aangifte = {} as Aangifte;
    public incomeTaxEntity = {} as IncomeTaxEntity;
    public partnerBoolean = {} as boolean;
    public isDefAangifte = {} as boolean;
    public loonInWinstFg = {} as FormGroup;
    public heeftWinstUitOnderneming = {} as boolean;

    constructor(public dataService: BokkzIbDataService, public dataAlgService: BokkzAlgDataService, private router: Router, private fb: FormBuilder) {
        this.loonInWinstFg = this.fb.group({
            loonAlsOnderdeelVanWinst: null as unknown as number,
            loonheffingOverLoonAlsOnderdeelVanWinst: null as unknown as number,
        })
    }

    public ngOnInit(): void {
        this.isDefAangifteSubscription = this.dataService.isDefAangifte.subscribe((isDefAangifte) => {
            this.isDefAangifte = isDefAangifte;
        });
        this.incomeTaxEntitySubscription = this.dataService.incomeTaxEntity.subscribe((incomeTaxEntity) => {
            this.incomeTaxEntity = incomeTaxEntity;
            if (incomeTaxEntity.aangifte) {
                const aangifte = incomeTaxEntity.aangifte;
                this.aangifte = aangifte;
                if (this.aangifte.box1?.winstUitOnderneming != undefined) {
                    this.heeftWinstUitOnderneming = true
                }
                this.partnerAangifte = aangifte.partnerAangifte ? aangifte.partnerAangifte : {} as Aangifte;
                this.updateForm();
                this.partner.subscribe((partner) => {
                    this.partnerBoolean = partner
                    this.loonInWinstFg.reset()
                    this.heeftWinst();
                    this.updateForm();
                });
            }
        });
      this.clientEntitySubscription = this.dataAlgService.client.subscribe((client) =>{
        this.clientId=client.sstRelationId!;
      });
        this.routerSubscription = this.router.events
            .pipe(filter((event: Event): event is NavigationEnd => event instanceof NavigationEnd))
            .subscribe((event: NavigationEnd) => {
                this.handleUrlChange(event.urlAfterRedirects);
            });
    }

    ngOnDestroy(): void {
        if (this.routerSubscription) {
            this.routerSubscription.unsubscribe();
        }
        if (this.incomeTaxEntitySubscription) {
            this.incomeTaxEntitySubscription.unsubscribe();
        }
        if (this.clientEntitySubscription) {
            this.clientEntitySubscription.unsubscribe();
        }
        if (this.isDefAangifteSubscription) {
            this.isDefAangifteSubscription.unsubscribe();
        }
    }

    handleUrlChange(newUrl: string) {
        if (!this.isSaving && this.hasUnsavedChanges()) {
            this.isSaving = true;
            this.dataService.postIncomeTaxEntityMetLoonheffing(this.clientId, false, this.incomeTaxEntity);
            this.isSaving = false;
        }
    }

    private hasUnsavedChanges(): boolean {
        return this.loonInWinstFg.dirty
    }

    private updateForm(): void {
        this.partner.subscribe((partner) => {
                if (!partner) {
                    this.loonInWinstFg.patchValue({
                        loonAlsOnderdeelVanWinst: this.aangifte?.voorheffingen?.loonAlsOnderdeelVanWinst,
                        loonheffingOverLoonAlsOnderdeelVanWinst: this.aangifte?.voorheffingen?.loonheffingOverLoonAlsOnderdeelVanWinst,
                    });
                } else {
                    this.loonInWinstFg.patchValue({
                        loonAlsOnderdeelVanWinst: this.aangifte?.partnerAangifte?.voorheffingen?.loonAlsOnderdeelVanWinst,
                        loonheffingOverLoonAlsOnderdeelVanWinst: this.aangifte?.partnerAangifte?.voorheffingen?.loonheffingOverLoonAlsOnderdeelVanWinst,
                    });
                }
            }
        )
    }

    saveForm(): void {
        if (!this.partnerBoolean) {
            this.incomeTaxEntity.aangifte = {
                ...this.aangifte,
                voorheffingen: {
                    ...this.aangifte.voorheffingen,
                    loonAlsOnderdeelVanWinst: this.loonInWinstFg.value.loonAlsOnderdeelVanWinst,
                    loonheffingOverLoonAlsOnderdeelVanWinst: this.loonInWinstFg.value.loonheffingOverLoonAlsOnderdeelVanWinst,
                }
            } as Aangifte;
            this.dataService.updateIncomeTaxEntity(this.incomeTaxEntity);

        } else {
            this.incomeTaxEntity.aangifte = {
                ...this.aangifte,
                partnerAangifte: {
                    ...this.aangifte.partnerAangifte,
                    voorheffingen: {
                        ...this.aangifte.voorheffingen,
                        loonAlsOnderdeelVanWinst: this.loonInWinstFg.value.loonAlsOnderdeelVanWinst,
                        loonheffingOverLoonAlsOnderdeelVanWinst: this.loonInWinstFg.value.loonheffingOverLoonAlsOnderdeelVanWinst,
                    }
                },
            } as Aangifte;
            this.dataService.updateIncomeTaxEntity(this.incomeTaxEntity);
        }
    }

    heeftWinst(): boolean {
        if (this.partnerBoolean) {
            if (this.aangifte.partnerAangifte?.box1?.winstUitOnderneming != undefined) {
                return true;
            }
        } else {
            if (this.aangifte.box1?.winstUitOnderneming != undefined) {
                return true;
            }
        }
        return false;
    }

}
